import { VideoService } from "./video.service";

export abstract class VideoFilterService {

    originalStream: MediaStream | null = null
    filteredStream: MediaStream | null = null

    isFiltering: boolean = false
    isStarting: boolean = false

    constructor(
        protected videoService: VideoService
    ) { }

    abstract applyFilter(mediaStream: MediaStream, args: string[], params: any): MediaStream;
    abstract removeFilter(mediaStream: MediaStream): MediaStream;

}